import { defineMessages } from 'react-intl'

export default defineMessages({
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  clientId: {
    id: 'OrganizationAuditConnectorPage.ClientId',
    defaultMessage: 'Client Id'
  },
  copy: {
    id: 'COPY',
    defaultMessage: 'COPY'
  },
  create: {
    id: 'OrganizationAuditConnectorPage.CreateCredentials',
    defaultMessage: 'Create Credentials'
  },
  description: {
    id: 'OrganizationAuditConnectorPage.Description',
    defaultMessage: 'For Organizations that want to use an API to access Workgrid Audit Logs.'
  },
  none: {
    id: 'None',
    defaultMessage: 'None'
  },
  onlyDisplayedOnce: {
    id: 'OnlyDisplayedOnce',
    defaultMessage: '(this is only displayed once!)'
  },
  pageTitle: {
    id: 'OrganizationAuditConnectorPage.Title',
    defaultMessage: 'API Management'
  },
  reset: {
    id: 'Reset',
    defaultMessage: 'Reset'
  },
  secret: {
    id: 'OrganizationAuditConnectorPage.ClientSecret',
    defaultMessage: 'Client Secret'
  }
})
